/**
 * Дождаться, когда карта закончит отрисовку.
 *
 * Нужно записи: кадр снимается с полотна карты, и снимать его надо ПОСЛЕ того,
 * как MapLibre нарисовал только что поданную геометрию, а не до. Сигнал —
 * `idle` («рисовать больше нечего»), а не `render`: обновление GeoJSON-источника
 * уходит в воркер, и ближайший `render` может прийти ещё со старыми данными.
 *
 * Потолок ожидания обязателен: `idle` не придёт, пока догружается хоть одна
 * плитка, а из-за одной плитки вся запись вставать не должна — лучше снять кадр
 * чуть раньше, чем подвесить кнопку.
 */
export interface IdleSource {
  once(type: string, listener: () => void): unknown
  off(type: string, listener: () => void): unknown
}

export const MAP_IDLE_TIMEOUT_MS = 500

export function waitMapIdle(map: IdleSource, timeoutMs = MAP_IDLE_TIMEOUT_MS): Promise<void> {
  return new Promise<void>(resolve => {
    let done = false
    const finish = () => {
      if (done) return
      done = true
      clearTimeout(timer)
      map.off('idle', onIdle)
      resolve()
    }
    const onIdle = () => finish()
    const timer = setTimeout(finish, timeoutMs)
    map.once('idle', onIdle)
  })
}
